export default __webpack_public_path__ + "static/media/deva.7288f53c.jpg";